import type { CommandingViewMode } from "owa-outlook-service-option-store";
import { getStore } from "../store/store";

export const getRibbonViewMode = (): CommandingViewMode => getStore().viewMode;
